import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';

export const PillsContainer = styled(FlexView)`
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 8px;
`;
